var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"problemsSection",staticClass:"section section-problems"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"section-title"},[_vm._v("传统医药广阔市场，普遍面临六大难题")]),_c('div',{staticClass:"problems-content"},[_c('div',{staticClass:"problem-circle-wrapper"},[_c('div',{staticClass:"problem-center-point"},[_c('CircleCom')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }